import React, { useEffect, useState } from 'react';
import { AlertTriangle, MessageSquare } from 'lucide-react';
import { createOrGetDeliveryConversation } from './api';
import ConversationThread from './ConversationThread';

export default function DeliveryCommunicationPanel({
  deliveryPointId,
  currentUserId,
  currentUserType = 'admin',
  className = '',
  autoScrollMessages = true,
  autoScrollOnInitialLoad = true,
}) {
  const [conversationId, setConversationId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadConversation() {
      if (!deliveryPointId) return;
      setIsLoading(true);
      setError(null);
      try {
        const conversation = await createOrGetDeliveryConversation(deliveryPointId, {
          created_by_user_id: currentUserId,
          viewer_type: currentUserType,
        });
        if (!cancelled) setConversationId(conversation?.id || null);
      } catch (err) {
        console.error('Delivery communication error:', err);
        if (!cancelled) setError('No se pudo iniciar la conversación');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    loadConversation();
    return () => {
      cancelled = true;
    };
  }, [deliveryPointId, currentUserId, currentUserType]);

  if (!deliveryPointId) return null;

  if (error) {
    return (
      <div className={`rounded-xl border border-red-200 bg-red-50 p-4 text-red-700 ${className}`}>
        <div className="flex items-center gap-2 font-bold">
          <AlertTriangle className="h-4 w-4" />
          Comunicación no disponible
        </div>
        <p className="mt-1 text-sm">{error}</p>
      </div>
    );
  }

  if (isLoading && !conversationId) {
    return (
      <div className={`rounded-xl border border-slate-200 bg-slate-50 p-6 text-center text-sm text-slate-500 ${className}`}>
        <MessageSquare className="mx-auto mb-2 h-8 w-8 text-slate-300" />
        Preparando conversación...
      </div>
    );
  }

  return (
    <ConversationThread
      conversationId={conversationId}
      currentUserId={currentUserId}
      currentUserType={currentUserType}
      className={className}
      autoScrollMessages={autoScrollMessages}
      autoScrollOnInitialLoad={autoScrollOnInitialLoad}
    />
  );
}
